// extracted by mini-css-extract-plugin
module.exports = {"content":"Drawer_content__KfK23"};